var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CChartPie',{attrs:{"labels":_vm.labelField,"datasets":[
      {
        backgroundColor: _vm.colors,
        data: _vm.dataField,
      },
    ],"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }